import { symbol } from "./symbol.js";
<ebay-icon ...input _name="dollar-16" _size="16" _type="icon" _themes=symbol/>